module.exports = __webpack_public_path__ + "static/media/icon-status-waiting.10ac092b.svg";